var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-container"},[_c('el-pagination',{staticClass:"pagination",attrs:{"background":"","layout":"prev, pager, next, total","total":_vm.total,"page-size":_vm.pageSize,"current-page":_vm.currentPage},on:{"current-change":_vm.onChangePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }